import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';
import Queue from '../../../../queue/QueueContainer';

const DownloadPaylocityReportButton = ({
  startDate,
  endDate,
  endingDateMax,
}) => (
  <div className="u-inline-block u-ml">
    <Queue
      name="reports"
      btnLabel={t('reports:payouts.paylocity_button')}
      btnClass="c-btn c-btn--primary"
      jobName="paylocity-report"
      label={t('reports:payouts.paylocity_label')}
      filters={{
        startDate,
        endDate,
      }}
      canEditDateRange
      isFixedRange
      fixedRangeDays={13}
      endingDateMax={endingDateMax}
      dateOnly
    />
  </div>
);

DownloadPaylocityReportButton.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  endingDateMax: PropTypes.object, // eslint-disable-line
};

export default DownloadPaylocityReportButton;
